import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args))),
    type: "button",
    title: _ctx.title,
    class: _normalizeClass(["btn btn-hero js-submit", `${_ctx.design ? 'btn-' + _ctx.design : ''} ${_ctx.hasSlotData ? 'btn-icon' : ''} ${_ctx.fullWidth ? 'btn-block' : ''}`])
  }, [
    _renderSlot(_ctx.$slots, "iconBefore"),
    _createTextVNode(" " + _toDisplayString(_ctx.text) + " ", 1),
    _renderSlot(_ctx.$slots, "iconAfter")
  ], 10, _hoisted_1))
}